export const readTableChartOpen = () =>
  window.localStorage.getItem('table-chart-open') === 'true';

export const readTableChartHiddenSeries = () =>
  JSON.parse(window.localStorage.getItem('table-chart-hidden-series') || '{}');

export const readTableChartHiddenSeriesDashboard = () =>
  JSON.parse(window.localStorage.getItem('table-chart-hidden-series-dashboard') || '{}');

export const createInitialTableUiState = () => ({
  total: 0,
  currentReport: null as unknown | null,
  nextReportTreeLevel: 0,
  nextReportGroup: null as unknown | null,
  customGroups: null as Record<string, unknown> | null,
  selectedItems: [] as unknown[],
  exportParams: null as unknown | null,
  previewLink: null as unknown | null,
  loading: false,
  drilldownFilter: null as unknown | null,
  drilldown: null as unknown | null,
  notesOpened: false,
  chartOpen: readTableChartOpen(),
  chartHiddenSeries: readTableChartHiddenSeries(),
  chartHiddenSeriesDashboard: readTableChartHiddenSeriesDashboard(),
  isHideFilters: false,
  noReportBlockVisible: false,
  progressBlockVisible: false,
  entityNames: {} as Record<string, unknown>,
  customEvents: {} as Record<string, unknown>,
  lastActiveTab: null as unknown | null,
});
